import React from 'react';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function CountryResourcesCountryTag (props) {
    return (
        <div className="country-tag">
          <div style={{paddingRight: '20px'}}>
            {props.country.slice(0, 20)}
          </div>
          <div style={{cursor: "pointer"}} onClick={ () => props.onDeleteCountry(props.country)}>
            x
          </div>
        </div>
      );
  }

  export default CountryResourcesCountryTag;


// <div className="country-tag">
//   <div>
//     <div>
//       {props.country.slice(0, 20)}
//     </div>
//   </div>
//   <span style={{cursor: "pointer"}} onClick={ () => props.onDeleteCountry(props.country)}>
//     x
//   </span>
// </div>


// WEBPACK FOOTER //
// ./src/components/CountryResourcesCountryTag.js